import logger from '../logger';

export const setLocalStorage = (key, value) => {
  try {
    return window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    return undefined;
  }
};

export const getLocalStorage = (key) => {
  try {
    const value = window.localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (e) {
    return null;
  }
};

export const removeItemFromLocalStorage = (key: string): void => {
  try {
    window.localStorage.removeItem(key);
  } catch (e) {
    logger.info({ msg: `could not remove ${key} from local storage` });
  }
};
